/* @flow */
import * as React from 'react';

// Utils
import { isVirtualLocation } from '@braindate/domain/lib/location/util';
import { getBraindateLocation } from '@braindate/domain/lib/braindate/util';
import {
  isBraindateCheckInReady,
  isBraindateVideoCallReady,
} from 'src/shared/domain/braindate/util/braindateUtil';

// Hooks
import useFeatureDecisions from 'src/shared/app/feature/hook/useFeatureDecisions';

// Styles
import styles from './UpcomingBraindateCardCheckIn.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Components
import CheckInActionButton from 'src/shared/app/check-in/component/notification/CheckInActionButton';

// Types
import type { Braindate } from '@braindate/domain/lib/braindate/type';

const useStyles = createUseThemeStyles(styles);

type Props = {
  braindate: Braindate,
  showCheckin: boolean,
};

const UpcomingBraindateCardCheckIn = ({ braindate, showCheckin }: Props) => {
  const classes = useStyles();
  const { isSelfCheckInEnabled } = useFeatureDecisions();

  const location = getBraindateLocation(braindate);
  const isVirtual = location && isVirtualLocation(location);

  const isReady = isVirtual
    ? isBraindateVideoCallReady(braindate)
    : isBraindateCheckInReady(braindate);

  if (!showCheckin || !isSelfCheckInEnabled || !isReady) return null;

  return (
    <div className={classes.root}>
      <CheckInActionButton braindate={braindate} />
    </div>
  );
};

export default React.memo<Props>(UpcomingBraindateCardCheckIn);
